<template>
  <a-row>
    <a-row style="margin-bottom: 16px;">
      <a-col span="4">
        <a-date-picker
          v-model="queryForm.riskDate"
          format="YYYY-MM-DD"
          placeholder="风控日期"
          style="width: 100%"
          allow-clear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-input
          v-model="queryForm.phoneNum"
          placeholder="手机号"
          allow-clear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-input
          v-model="queryForm.name"
          placeholder="姓名"
          allow-clear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-input
          v-model="queryForm.idNumber"
          placeholder="身份证号"
          allow-clear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-input
          v-model="queryForm.code"
          placeholder="工号"
          allow-clear
        />
      </a-col>
      <a-col span="4" style="padding-left: 8px; text-align: right;">
        <a-button type="primary" :loading="loading" @click="handleSearch">
          <a-icon type="search" /> 搜索
        </a-button>
        <a-button style="margin-left: 8px;" @click="handleReset">
          <a-icon type="reload" /> 重置
        </a-button>
      </a-col>
    </a-row>
    <a-row style="margin-bottom: 16px;">
      <a-col span="4">
        <a-select
          v-model="queryForm.type"
          placeholder="账号类型"
          allow-clear
          style="width: 100%"
        >
          <a-select-option :value="0">学生</a-select-option>
          <a-select-option :value="1">老师</a-select-option>
        </a-select>
      </a-col>
      <a-col span="4" style="padding-left: 8px;">
        <a-select
          v-model="queryForm.frozen"
          placeholder="冻结状态"
          allow-clear
          style="width: 100%"
        >
          <a-select-option :value="true">已冻结</a-select-option>
          <a-select-option :value="false">未冻结</a-select-option>
        </a-select>
      </a-col>
    </a-row>

    <a-table
      :columns="columns"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      row-key="id"
      :scroll="{ x: 1320 }"
      @change="handleTableChange"
    >
      <div slot="nameIdNumber" slot-scope="text, record">
        <div class="account-meta-col">
          <div class="account-meta-line">
            <span class="account-meta-k">姓名</span>
            <span class="account-meta-v account-ellipsis" :title="record.name != null ? String(record.name) : ''">{{
              record.name != null && String(record.name).trim() ? record.name : '—'
            }}</span>
          </div>
          <div class="account-meta-line">
            <span class="account-meta-k">身份证号</span>
            <span class="account-meta-v account-ellipsis" :title="record.idNumber != null ? String(record.idNumber) : ''">{{
              record.idNumber != null && String(record.idNumber).trim() ? record.idNumber : '—'
            }}</span>
          </div>
        </div>
      </div>

      <div slot="typeFrozen" slot-scope="text, record">
        <div class="account-meta-col">
          <div class="account-meta-line account-meta-line--tags">
            <div class="account-meta-v account-meta-tags">
              <a-tag v-if="record.type === 0" color="blue">学生</a-tag>
              <a-tag v-else-if="record.type === 1" color="green">老师</a-tag>
              <a-tag v-else color="default">未知</a-tag>
            </div>
          </div>
          <div class="account-meta-line account-meta-line--tags">
            <div class="account-meta-v account-meta-tags">
              <a-tag v-if="record.frozen === true" color="red">已冻结</a-tag>
              <a-tag v-else-if="record.frozen === false" color="green">未冻结</a-tag>
              <span v-else>—</span>
            </div>
          </div>
        </div>
      </div>

      <div slot="riskBriefCol" slot-scope="text, record">
        <div v-if="record.dailyRiskStat" class="account-meta-col">
          <div class="account-meta-line">
            <span class="account-meta-k">总记录数</span>
            <span class="account-meta-v">{{ formatDailyRiskStatValue('totalRows', record.dailyRiskStat.totalRows) }}</span>
          </div>
          <div class="account-meta-line">
            <span class="account-meta-k">风控命中</span>
            <span class="account-meta-v">{{ formatDailyRiskStatValue('riskRows', record.dailyRiskStat.riskRows) }}</span>
          </div>
          <div class="account-meta-line">
            <span class="account-meta-k">累计耗时</span>
            <span class="account-meta-v">{{ formatDailyRiskStatValue('totalCostTimeMs', record.dailyRiskStat.totalCostTimeMs) }}</span>
          </div>
        </div>
        <span v-else style="color: #999;">—</span>
      </div>

      <div slot="studentInfo" slot-scope="text, record">
        <div v-if="record.type === 0 && record.jwStudentList && record.jwStudentList.length > 0">
          <div
            v-for="(student, index) in record.jwStudentList"
            :key="student.id"
            style="margin-bottom: 8px; padding: 8px; border: 1px solid #f0f0f0; border-radius: 4px; background-color: #fafafa;"
          >
            <div style="font-size: 12px; color: #666; margin-bottom: 4px;">
              学籍信息 {{ index + 1 }}
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 8px; font-size: 12px;">
              <span><strong>学号：</strong>{{ student.code || '-' }}</span>
              <span><strong>院系：</strong>{{ student.jwDeptName || '-' }}</span>
              <span><strong>专业：</strong>{{ student.jwMajorName || '-' }}</span>
              <span><strong>班级：</strong>{{ student.jwClazzName || '-' }}</span>
              <span><strong>状态：</strong>{{ student.schoolRollLabel || '-' }}</span>
            </div>
          </div>
        </div>
        <div v-else-if="record.type === 0" style="color: #999; font-size: 12px;">
          暂无学籍信息
        </div>
        <div v-else style="color: #999; font-size: 12px;">
          非学生账号
        </div>
      </div>

      <span slot="action" slot-scope="text, record">
        <CommonPermissions :p="$permissions.ACCOUNT_MGT.RETRIEVE">
          <a @click="() => openRiskStatDrawer(record)">风控统计</a>
        </CommonPermissions>
        <template v-if="record.type === 0">
          <CommonPermissions :p="$permissions.ACCOUNT_MGT.UPDATE">
            <a-divider type="vertical" />
            <a @click="() => openFreezeRecordDrawer(record)">冻结记录</a>
          </CommonPermissions>
          <CommonPermissions :p="$permissions.ACCOUNT_MGT.UPDATE">
            <a-divider type="vertical" />
            <a v-if="record.frozen !== true" @click="() => openFreezeModal(record)">冻结</a>
            <span v-else class="op-muted">冻结</span>
          </CommonPermissions>
          <CommonPermissions :p="$permissions.ACCOUNT_MGT.UPDATE">
            <a-divider type="vertical" />
            <a-popconfirm
              v-if="record.frozen === true"
              title="确定解除该账号的冻结？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="() => unfreezeRow(record)"
            >
              <a>解除冻结</a>
            </a-popconfirm>
            <span v-else class="op-muted">解除冻结</span>
          </CommonPermissions>
        </template>
        <span v-else class="op-muted" style="font-size: 12px;">仅学生支持冻结</span>
      </span>
    </a-table>

    <a-drawer
      title="风控统计"
      placement="right"
      width="520"
      :closable="true"
      :visible="showRiskStatDrawer"
      :destroyOnClose="true"
      @close="closeRiskStatDrawer"
    >
      <div v-if="riskStatAccount" style="margin-bottom: 16px; color: rgba(0,0,0,0.65);">
        <span><strong>姓名：</strong>{{ riskStatAccount.name || '—' }}</span>
        <span style="margin-left: 16px;"><strong>手机号：</strong>{{ riskStatAccount.phoneNum || '—' }}</span>
      </div>
      <template v-if="riskStatPayload">
        <a-descriptions :column="1" bordered size="small">
          <a-descriptions-item
            v-for="item in dailyRiskStatFields"
            :key="item.key"
            :label="item.label"
          >
            {{ formatDailyRiskStatValue(item.key, riskStatPayload[item.key]) }}
          </a-descriptions-item>
        </a-descriptions>
      </template>
      <a-empty v-else description="暂无风控统计数据" />
    </a-drawer>

    <a-drawer
      title="冻结记录"
      placement="right"
      width="65%"
      :closable="true"
      :visible="showFreezeRecordDrawer"
      :destroyOnClose="true"
      @close="closeFreezeRecordDrawer"
    >
      <div v-if="freezeRecordAccount" style="margin-bottom: 12px; color: rgba(0,0,0,0.65);">
        <span><strong>姓名：</strong>{{ freezeRecordAccount.name || '—' }}</span>
        <span style="margin-left: 16px;"><strong>手机号：</strong>{{ freezeRecordAccount.phoneNum || '—' }}</span>
        <span style="margin-left: 16px;"><strong>身份证号：</strong>{{ freezeRecordAccount.idNumber || '—' }}</span>
      </div>
      <a-table
        :columns="freezeRecordColumns"
        :data-source="freezeRecordList"
        :loading="freezeRecordLoading"
        row-key="id"
        :pagination="false"
        size="small"
        :scroll="{ x: 900 }"
      >
        <span slot="fFreezeUntil" slot-scope="text">
          {{ text ? $moment(text).format('YYYY-MM-DD HH:mm:ss') : '—' }}
        </span>
        <span slot="fEnable" slot-scope="text">
          <a-tag v-if="text === 1" color="green">生效</a-tag>
          <a-tag v-else color="red">已失效</a-tag>
        </span>
        <span slot="fGmtCreate" slot-scope="text">
          {{ text ? $moment(text).format('YYYY-MM-DD HH:mm:ss') : '—' }}
        </span>
        <span slot="fGmtModified" slot-scope="text">
          {{ text ? $moment(text).format('YYYY-MM-DD HH:mm:ss') : '—' }}
        </span>
      </a-table>
    </a-drawer>

    <a-modal
      title="设置账号冻结"
      :visible="showFreezeModal"
      :confirmLoading="freezeSubmitting"
      ok-text="确定"
      cancel-text="取消"
      :destroyOnClose="true"
      @ok="submitFreeze"
      @cancel="closeFreezeModal"
    >
      <a-form-model ref="freezeFormRef" :model="freezeForm" :rules="freezeFormRules" layout="vertical">
        <a-form-model-item label="冻结截止时间" prop="freezeUntil">
          <a-date-picker
            v-model="freezeForm.freezeUntil"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
            placeholder="请选择冻结截止时间"
          />
        </a-form-model-item>
        <a-form-model-item label="冻结原因" prop="reason">
          <a-textarea
            v-model="freezeForm.reason"
            :rows="3"
            :maxLength="500"
            placeholder="选填，最多 500 字"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-row>
</template>

<script>
import { mapState } from 'vuex'
import AccountMgtApi from '@/api/src/account_mgt/api/AccountMgtApi'
import CommonPermissions from '@/components/CommonPermissions'

const accountMgtApi = new AccountMgtApi()

const freezeRecordColumns = [
  {
    title: '冻结截止时间',
    dataIndex: 'freezeUntil',
    key: 'freezeUntil',
    width: 180,
    scopedSlots: { customRender: 'fFreezeUntil' },
  },
  { title: '冻结原因', dataIndex: 'reason', key: 'reason', ellipsis: true },
  {
    title: '状态',
    dataIndex: 'enable',
    key: 'enable',
    width: 100,
    scopedSlots: { customRender: 'fEnable' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    width: 170,
    scopedSlots: { customRender: 'fGmtCreate' },
  },
  {
    title: '更新时间',
    dataIndex: 'gmtModified',
    key: 'gmtModified',
    width: 170,
    scopedSlots: { customRender: 'fGmtModified' },
  },
]

const columns = [
  {
    title: '姓名 / 身份证号',
    key: 'nameIdNumber',
    width: 260,
    scopedSlots: { customRender: 'nameIdNumber' },
  },
  {
    title: '手机号',
    dataIndex: 'phoneNum',
    key: 'phoneNum',
  },
  {
    title: '账号类型 / 冻结',
    key: 'typeFrozen',
    scopedSlots: { customRender: 'typeFrozen' },
  },
  {
    title: '异常数据',
    key: 'riskBriefCol',
    width: 220,
    scopedSlots: { customRender: 'riskBriefCol' },
  },
  {
    title: '学籍信息',
    key: 'studentInfo',
    width: 280,
    scopedSlots: { customRender: 'studentInfo' },
  },
  {
    title: '操作',
    key: 'action',
    width: 340,
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
  },
]

const dailyRiskStatFields = [
  { key: 'totalRows', label: '该账号总记录数' },
  { key: 'ipCount', label: '该账号涉及的 IP 数量' },
  { key: 'riskRows', label: '命中任一风控规则的记录数' },
  { key: 'totalCostTimeMs', label: '当日全部学习记录累计耗时' },
  { key: 'cntOverMaxCostTime', label: '命中单条耗时超上限次数' },
  { key: 'cntExitBeforeEnter', label: '命中退出早于进入次数' },
  { key: 'cntCostTimeMismatch', label: '命中区间时长小于上报耗时次数' },
  { key: 'cntDrillType0Effective0', label: '命中签名不合法调用次数' },
  { key: 'cntEnterTimeLt1s', label: '命中进入时间差小于 1 秒次数' },
  { key: 'cntExitTimeLt1s', label: '命中退出时间差小于 1 秒次数' },
  { key: 'cntDbOverlap', label: '命中重叠组耗时异常次数' },
  { key: 'cntRateAccountMin', label: '命中账号分钟频率超阈值次数' },
  { key: 'maxRateAccountMin', label: '账号分钟提交频率最高值' },
  { key: 'maxEnterSameSecRows', label: '同一秒进入最大记录条数' },
  { key: 'maxExitSameSecRows', label: '同一秒退出最大记录条数' },
  { key: 'cntRateIpMin', label: '命中 IP 分钟频率超阈值次数' },
  { key: 'maxRateIpMin', label: 'IP 分钟提交频率最高值' },
]

export default {
  name: 'DailyRiskAccount',
  components: {
    CommonPermissions,
  },
  data() {
    return {
      columns,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
      },
      queryForm: {
        riskDate: null,
        phoneNum: '',
        name: '',
        idNumber: '',
        code: '',
        type: undefined,
        frozen: undefined,
      },
      showFreezeRecordDrawer: false,
      freezeRecordLoading: false,
      freezeRecordList: [],
      freezeRecordAccount: null,
      freezeRecordColumns,
      showFreezeModal: false,
      freezeSubmitting: false,
      freezeOpRecord: null,
      freezeForm: {
        freezeUntil: null,
        reason: '',
      },
      freezeFormRules: {
        freezeUntil: [{ required: true, message: '请选择冻结截止时间', trigger: 'change' }],
      },
      showRiskStatDrawer: false,
      riskStatAccount: null,
      dailyRiskStatFields,
    }
  },
  computed: {
    ...mapState('security', {
      securityUser: (state) => state.user || {},
    }),
    riskStatPayload() {
      const acc = this.riskStatAccount
      if (!acc || acc.dailyRiskStat === undefined || acc.dailyRiskStat === null) return null
      return acc.dailyRiskStat
    },
  },
  mounted() {
    this.queryForm.riskDate = this.$moment().startOf('day')
    this.fetchList(1)
  },
  methods: {

    riskDateForBody() {
      const d = this.queryForm.riskDate
      if (!d) return undefined
      const m = this.$moment.isMoment(d) ? d.clone() : this.$moment(d)
      if (!m.isValid()) return undefined
      return m.format('YYYY-MM-DD')
    },

    buildQueryBody(pageNum) {
      const body = {
        pageNum,
        pageSize: this.pagination.pageSize,
        riskDate: this.riskDateForBody(),
      }
      if (this.queryForm.phoneNum) body.phoneNum = this.queryForm.phoneNum
      if (this.queryForm.name) body.name = this.queryForm.name
      if (this.queryForm.idNumber) body.idNumber = this.queryForm.idNumber
      if (this.queryForm.code) body.code = this.queryForm.code
      if (this.queryForm.type === 0 || this.queryForm.type === 1) body.type = this.queryForm.type
      if (this.queryForm.frozen === true || this.queryForm.frozen === false) {
        body.frozen = this.queryForm.frozen
      }
      return body
    },

    async fetchList(pageNum) {
      if (!this.queryForm.riskDate) {
        this.$message.warning('请选择风控日期')
        return
      }
      this.loading = true
      try {
        const resp = await accountMgtApi.findPageDailyRiskAccount(this.buildQueryBody(pageNum))
        this.data = resp.list || []
        this.pagination.current = resp.pageNum || 1
        this.pagination.total = resp.total || 0
        if (resp.pageSize) this.pagination.pageSize = resp.pageSize
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '获取每日风控账号失败')
      } finally {
        this.loading = false
      }
    },

    handleSearch() {
      this.pagination.current = 1
      this.fetchList(1)
    },

    handleReset() {
      this.queryForm = {
        riskDate: this.$moment().startOf('day'),
        phoneNum: '',
        name: '',
        idNumber: '',
        code: '',
        type: undefined,
        frozen: undefined,
      }
      this.pagination.current = 1
      this.fetchList(1)
    },

    handleTableChange(pag) {
      this.fetchList(pag.current)
    },

    openRiskStatDrawer(record) {
      this.riskStatAccount = record
      this.showRiskStatDrawer = true
    },
    closeRiskStatDrawer() {
      this.showRiskStatDrawer = false
      this.riskStatAccount = null
    },

    formatDailyRiskStatValue(key, val) {
      if (val === undefined || val === null) return '—'
      if (key === 'totalCostTimeMs') {
        const n = Number(val)
        if (!Number.isFinite(n) || n < 0) return String(val)
        const totalSec = Math.floor(n / 1000)
        const h = Math.floor(totalSec / 3600)
        const m = Math.floor((totalSec % 3600) / 60)
        const s = totalSec % 60
        return `${h}小时${m}分钟${s}秒`
      }
      return val
    },

    openFreezeRecordDrawer(record) {
      this.freezeRecordAccount = record
      this.showFreezeRecordDrawer = true
      this.loadFreezeRecordList(record.id)
    },
    closeFreezeRecordDrawer() {
      this.showFreezeRecordDrawer = false
      this.freezeRecordAccount = null
      this.freezeRecordList = []
    },
    async loadFreezeRecordList(accountId) {
      this.freezeRecordLoading = true
      this.freezeRecordList = []
      try {
        const list = await accountMgtApi.getAccountFreezeList(accountId)
        this.freezeRecordList = Array.isArray(list) ? list : []
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '获取冻结记录失败')
      } finally {
        this.freezeRecordLoading = false
      }
    },

    openFreezeModal(record) {
      this.freezeOpRecord = record
      this.freezeForm = { freezeUntil: null, reason: '' }
      this.showFreezeModal = true
      this.$nextTick(() => {
        if (this.$refs.freezeFormRef && this.$refs.freezeFormRef.clearValidate) {
          this.$refs.freezeFormRef.clearValidate()
        }
      })
    },
    closeFreezeModal() {
      this.showFreezeModal = false
      this.freezeOpRecord = null
      this.freezeForm = { freezeUntil: null, reason: '' }
    },
    submitFreeze() {
      return new Promise((resolve, reject) => {
        this.$refs.freezeFormRef.validate((valid) => {
          if (!valid) {
            reject()
            return
          }
          this.freezeSubmitting = true
          const m = this.freezeForm.freezeUntil
          const freezeUntil = m && typeof m.toDate === 'function' ? m.toDate() : m
          const body = {
            freezeUntil,
            reason: (this.freezeForm.reason && this.freezeForm.reason.trim()) || undefined,
          }
          accountMgtApi
            .freezeAccount(this.freezeOpRecord.id, body)
            .then(() => {
              this.$message.success('已设置冻结')
              this.closeFreezeModal()
              this.fetchList(this.pagination.current)
              resolve()
            })
            .catch((e) => {
              this.$message.error((e && e.message) || '操作失败')
              reject(e)
            })
            .finally(() => {
              this.freezeSubmitting = false
            })
        })
      })
    },

    async unfreezeRow(record) {
      try {
        await accountMgtApi.unfreezeAccount(record.id)
        this.$message.success('已解除冻结')
        await this.fetchList(this.pagination.current)
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '操作失败')
      }
    },
  },
}
</script>

<style scoped lang="less">
.ant-table-wrapper {
  margin-top: 16px;
}

.account-meta-col {
  min-width: 0;
  line-height: 1.5;
}

.account-meta-line {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;

  & + & {
    margin-top: 4px;
  }
}

.account-meta-k {
  flex: none;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
}

.account-meta-v {
  flex: 1;
  min-width: 0;
}

.account-meta-line--time {
  align-items: center;

  .account-meta-v {
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }
}

.account-meta-line--tags {
  align-items: center;
}

.account-meta-tags {
  line-height: 1.5;
}

.account-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.op-muted {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  user-select: none;
}
</style>
